import { render } from "./AdminLabel.vue?vue&type=template&id=1aea3897&scoped=true"
import script from "./AdminLabel.vue?vue&type=script&lang=js"
export * from "./AdminLabel.vue?vue&type=script&lang=js"

import "./AdminLabel.vue?vue&type=style&index=0&id=1aea3897&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aea3897"]])

export default __exports__